import { COOKIE_NAMES } from '../constants';
import { getCookieByName, getCookieData } from '../cookies';
import { gatekeeper } from '../gatekeeper';

export const getGlobalGtmParams = () => {
  const bannerId = getCookieData(COOKIE_NAMES.KAZUMO_MEDIUM, 'bannerId');
  const btag = getCookieData(COOKIE_NAMES.KAZUMO_MEDIUM, 'btag');

  return {
    kazumoTrackingId: getCookieByName(COOKIE_NAMES.KAZUMO_TRACKING_ID) ?? '',
    lang:             gatekeeper?.localisation?.localeCode ?? '',
    market:           gatekeeper?.localisation?.marketSlug ?? '',
    affTrackId:       bannerId ? String(bannerId).substring(0, 6) : '',
    btag:             btag || '',
  };
};
